<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                {{'businessIntelligence.tol.dealers'}}
              </div>
              <span #dealers class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                {{dealer.nome}}
                <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
              </span>
              <div class="botao">
                <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                  <em class="fa fa-plus"></em>
                </button>
              </div>
              <div class="clear"></div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.tol.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataInicial()"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.tol.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataFinal()"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button pButton type="button" class="p-button-sm p-button-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'businessIntelligence.tol.filtrar' | translate}}
                  <i class="pi pi-search ml-1"></i>
                </button>
                <button pButton type="button" class="p-button-sm p-button-secondary mt-3 mr-2" icon="pi pi-filter-slash"
                  iconPos="right" (click)="limparFiltros()" pTooltip="Limpar Filtros">
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <app-loading [exibir]="carregando"></app-loading>
    <div *ngIf="!carregando">

      <div translate *ngIf="registros?.length <= 0" class="sem-registros text-muted mt-2">
        {{'businessIntelligence.tol.nenhumRegistroExibir'}}
      </div>
      <p-table #dt id="principal" *ngIf="registros?.length > 0" [columns]="columnsSynthetic" [value]="registros"
        class="style" styleClass="p-datatable-striped p-datatable-sm mt-2" [rowHover]="true" [autoLayout]="true"
        [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columnsSynthetic">
              <th class="text-center" [translate]="getTranslate(col.header)">
                {{col.header}}
                <!-- <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" /> -->
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-registros let-columns="columnsSynthetic" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columnsSynthetic">
              <td *ngIf="col.field != 'errorsQuantity'" class="text-center">
                {{ registros[col.field] }}
              </td>
              <td *ngIf="col.field == 'errorsQuantity'" class="text-center">
                <a class="link" (click)="getDealerCode(rowIndex)">
                  {{ registros[col.field] }}
                </a>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="registrosAnalitico?.length > 0" class="mt-3">
      <hr>
      <p-table #dt id="target" [columns]="columnsAnalytical" [value]="registrosAnalitico" class="style"
        styleClass="p-datatable-striped p-datatable-sm mt-4" [rowHover]="true" [autoLayout]="true" [autoLayout]="true"
        [paginator]="registrosAnalitico.length > 10" [rows]="rowsAn" [(first)]="firstAn" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'businessIntelligence.tol.mostrandoRegistrosAnalitico' | translate}}"
        [rowsPerPageOptions]="[10,20,30,50,100]">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columnsAnalytical">
              <th class="text-center" [translate]="getTranslate(col.header)" [ngStyle]="{'width': col.width}">
                {{col.header}}
                <!-- <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" /> -->
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-registrosAnalitico let-columns="columnsAnalytical" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columnsAnalytical">
              <td *ngIf="col.field != 'description' && col.field != 'message'" class="text-center">
                <div [translate]="getTranslate(registrosAnalitico[col.field])">
                  {{ col.type ? col.type.transform(registrosAnalitico[col.field], col.arg1, col.arg2) : registrosAnalitico[col.field] }}
                  <ng-container *ngIf="col.field == 'serviceType'" [translate]="getTranslate(registrosAnalitico)">
                  </ng-container>
                </div>
              </td>
              <td *ngIf="col.field == 'description'" class="text-center link-comments"
                (click)="abrirComentarios(rowIndex)" pTooltip="Clique Aqui para Visualizar">
                <p class="comentarios">{{ registrosAnalitico[col.field] }}</p>
              </td>
              <td *ngIf="col.field == 'message'" class="text-center link-comments" (click)="abrirMensagens(rowIndex)"
                pTooltip="Clique Aqui para Visualizar">
                <p class="comentarios">{{ registrosAnalitico[col.field] }}</p>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- <p-dialog header="{{'businessIntelligence.tol.selecioneDealers' | translate}}" [(visible)]="displayFiltrosDealers"
  [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->
<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-dialog header="{{'businessIntelligence.tol.comentarios' | translate}}" [(visible)]="displayComentarios"
  [style]="{width: '500px'}" [modal]="true" [draggable]="false" (onHide)="fecharComentarios()">
  <textarea cols="58" rows="10" disabled>
    {{ textoComment }}
  </textarea>
</p-dialog>

<p-dialog header="{{'businessIntelligence.tol.mensagens' | translate}}" [(visible)]="displayMensagens"
  [style]="{width: '500px'}" [modal]="true" [draggable]="false" (onHide)="fecharMensagens()">
  <textarea cols="58" rows="10" disabled>
    {{ textoMessage }}
  </textarea>
</p-dialog>

<p-toast key="businessIntelligenceDetalhado" position="bottom-right"></p-toast>
